import React, {useState} from 'react';
import {useMutation} from 'react-apollo-hooks';
import gql from 'graphql-tag';

import {useAuth} from 'context';
import {Button, Card, Input, PlainButton, Loading} from 'ui-kit';

import * as styles from './Signup.module.css';

export function Signup({showLogin}) {
  const {login} = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const mutate = useMutation(gql`
    mutation CreatePractice($input: CreatePracticeInput!) {
      createPractice(input: $input) {
        token
        errors {
          path
          message
        }
      }
    }
  `);

  async function handleSubmit(event) {
    event.preventDefault();

    setLoading(true);

    try {
      const {data} = await mutate({
        variables: {
          input: {
            practiceName: name,
            staffMemberEmail: email,
            staffMemberPassword: password,
            staffMemberPasswordConfirmation: passwordConfirmation,
          },
        },
      });

      const {errors, token} = data.createPractice;

      if (errors.length > 0) {
        setErrors(
          errors.reduce((errorObj, {path, message}) => {
            const fullMessage =
              errorObj[path] == null
                ? message
                : `${errorObj[path]}; ${message}`;

            return {
              [path]: fullMessage,
              ...errorObj,
            };
          }, {}),
        );
        return;
      }

      login(token);
    } catch (error) {}
  }

  return (
    <div className={styles.Container}>
      <Card>
        <h1>Sign up</h1>

        <p>
          Already have an account?{' '}
          <PlainButton type="button" onClick={showLogin}>
            Log in
          </PlainButton>
        </p>

        <form method="post" onSubmit={handleSubmit}>
          <Input
            label="Practice name"
            name="name"
            value={name}
            onChange={event => setName(event.target.value)}
            errorMessage={errors.name}
          />

          <Input
            label="Email"
            name="email"
            value={email}
            onChange={event => setEmail(event.target.value)}
            errorMessage={errors.email}
          />

          <Input
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={event => setPassword(event.target.value)}
            errorMessage={errors.password}
          />

          <Input
            label="Confirm password"
            name="passwordConfirmation"
            type="password"
            value={passwordConfirmation}
            onChange={event => setPasswordConfirmation(event.target.value)}
            errorMessage={errors.passwordConfirmation}
          />

          <Button type="submit" block disabled={loading}>
            {loading ? <Loading immediate /> : 'Continue'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
